module.exports = __webpack_public_path__ + "static/eip_highlight-13be4bee4b484443d4698b168beb709f.jpg";